import React from 'react';
import BookCover from '../components/Book';
import SectionTitle from '../components/SectionTitle';
import Button from "../components/Button";
import Truncate from 'react-truncate-html'; 
import { Grid, Row, Col } from 'react-bootstrap';
import config from '../config'

class BooksHome extends React.Component {
    render(){
        let testBook
        for (var x = 0; x < this.props.booksData[0].books.length; x++){
            if (this.props.booksData[0].books[x]._doc === this.props.id){
                testBook = this.props.booksData[0].books[x]
            } 
        }

        //WWW-5749 - iBooks to Apple Books
        if(config.author === "cmessud") {
            for (let i = 0; i < testBook.retailersLinks.length; i++) {
                testBook.retailersLinks[i].retailer 
                    = testBook.retailersLinks[i].retailer === "iBooks" 
                        ? "Apple Books" : testBook.retailersLinks[i].retailer;
            }
        }

        //WWW-5750 - adding new links in buy now drowdown
        let confBook = config.books !== undefined ? config.books : null;
        let isFound = false;
        if(confBook !== null) {
            confBook.forEach(element => {
                if(element.title === testBook.title) {
                    element.retailersLinks.forEach(elem => {
                        testBook.retailersLinks.find(ele => {
                            if(ele.retailer === elem.retailer && isFound === false) {
                                isFound = true;
                            }
                        });
                        if(isFound === false) {
                            testBook.retailersLinks.push(elem);
                        }
                    })
                }
            });
        }

        //WWW-5750 - Sort the retailer links by retailer.
        if(config.author === "cmessud") {
            testBook.retailersLinks.sort(function (a, b) {
                var linkA = a.retailer.toUpperCase();
                var linkB = b.retailer.toUpperCase();
                if (linkA < linkB) {
                    return -1;
                }
                if (linkA > linkB) {
                    return 1;
                }
                return 0;
            });
        }

        let link = "/books/"+testBook.url;
        return (
            <Grid>
                <Row className="show-grid">
                    <div>
                        <Col xs={12} md={6}>
                            <div className="books-home-text">
                                <div className="section-title"> 
                                    <SectionTitle title={testBook.bookTitle} subtitle={testBook.subtitle}/>
                                </div>
                                <Truncate 
                                    id="testing"
                                    className="detail-description"
                                    ellipsis={" ..."}
                                    debounce={50}
                                    lines={7}
                                    dangerouslySetInnerHTML={{__html: testBook.summary}}>
                                </Truncate>
                                <a className="read-more" href={link}>Read More</a>
                            </div>
                        </Col>
                        <Col xs={12} md={6}>
                            <div className="books-home-cover">
                                <BookCover book={testBook} link={link}/>
                                <Button title={testBook.bookTitle} dropDownLinks={testBook.retailersLinks} text={testBook.orderButtonText} link="#" type="buy"/>
                            </div>
                        </Col>
                    </div>
                </Row>
            </Grid>
        )
    }
}

export default BooksHome;


// WEBPACK FOOTER //
// ./src/components/BooksHome.js